<template>
   <div class="zt_bj trading-panel" :class="{ 'book-expanded': bookOpen }">
    <div class="right-wrap stock-two-panels">
      <div class="stock-trade-scroll">
          <section class="stock-data-panel" :class="{ 'book-expanded': bookOpen }">
            <div class="title_jy_box">
                <div style="margin-left: 13px;">{{normalData.name}}[{{symbol}}]</div>
                <slot name="heading-actions" :stock-name="normalData.name" :contract-id="heyueid" />
            </div>
            <div class="title_jy_box">
                <div style="margin-left: 13px;">主要指标</div>
                <div style="margin-right: 13px;">
                  <button class="data-toggle" type="button" :aria-expanded="metricsOpen" @click="metricsOpen = !metricsOpen">{{ metricsOpen ? '收起' : '展开' }}</button>
                </div>
            </div>
            <div v-if="metricsOpen" class="china-metrics" v-loading="quoteBusy && !quoteReady" element-loading-background="var(--theme-bg)" style="display: flex;color: var(--theme-label);">
              <div style="width: 50%">
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">最高</div>
                        <div class="div_c_w5">{{ priceDisplay(normalData.high) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">今开</div>
                        <div class="div_c_w5">{{ priceDisplay(normalData.open) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">换手率</div>
                        <div class="div_c_w5">{{ metric(normalData.exchangerate, '%') }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">成交量</div>
                        <div class="div_c_w5">{{ metric(normalData.vol, '万', 1000000, 2) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">总市值</div>
                        <div class="div_c_w5">{{ metric(normalData.marketvalue, '亿', 1, 0) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">流通市值</div>
                        <div class="div_c_w5">{{ metric(normalData.flowmarketvalue, '亿', 1, 0) }}</div>
                    </div>
                </div>
                <div style="width: 50%;margin-bottom: 10px">
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">最低</div>
                        <div class="div_c_w5">{{ priceDisplay(normalData.low) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">昨收</div>
                        <div class="div_c_w5">{{ priceDisplay(normalData.yclose) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">振幅</div>
                        <div class="div_c_w5">{{ metric(normalData.amplitude, '%') }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">成交额</div>
                        <div class="div_c_w5">{{ metric(normalData.amount, '亿', 100000000, 2) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">市盈率</div>
                        <div class="div_c_w5">{{ metric(normalData.pe) }}</div>
                    </div>
                    <div class="flex flex-justify_between">
                        <div class="div_c_w5">市净率</div>
                        <div class="div_c_w5">{{ metric(normalData.pb) }}</div>
                    </div>
                </div>
            </div>

            <!-- 买卖盘口 -->
            <TradeTicks :symbol="symbol" :price-selectable="selPriceType === 0" @select-price="setLimitPrice" />
            <div class="title_jy_box">
                <div style="margin-left: 13px;">买卖盘口</div>
                <div style="margin-right: 13px;">
                  <button class="data-toggle" type="button" :aria-expanded="bookOpen" @click="bookOpen = !bookOpen">{{ bookOpen ? '收起' : '展开' }}</button>
                </div>
            </div>
            <div v-if="bookOpen" class="china-order-book" v-loading="quoteBusy && !quoteReady" element-loading-background="var(--theme-bg)" style="display: flex;color: var(--theme-label);">
                <div style="width: 50%">
                    <div>
                        <div v-for="(i,idx) in buySell1" class="flex flex-justify_between">
                            <div  class="div_c_t">买{{idx+1}}</div>
                            <div class="div_c_t" :class="priceTone(i.price)"><button type="button" class="quote-price" :disabled="selPriceType !== 0" title="点击填入限价" @click="setLimitPrice(i.price)">{{ priceDisplay(i.price) }}</button></div>
                            <div class="div_c_t">{{ metric(i.vol) }}</div>
                        </div>
                    </div>
                </div>
                <div style="width: 50%;margin-bottom: 10px">
                    <div>
                      <div v-for="(i,idx) in buySell2" class="flex flex-justify_between">
                        <div class="div_c_t">{{ metric(i.vol) }}</div>
                        <div class="div_c_t" :class="priceTone(i.price)"><button type="button" class="quote-price" :disabled="selPriceType !== 0" title="点击填入限价" @click="setLimitPrice(i.price)">{{ priceDisplay(i.price) }}</button></div>
                        <div class="div_c_t">卖{{idx+1}}</div>
                      </div>
                    </div>
                </div>
            </div>
            <!-- 买卖盘口 -->
            <div v-if="quoteError" role="alert" style="padding: 12px;">{{ quoteError }} <button type="button" @click="childMethod(0)">重试</button></div>
          </section>
          <section class="stock-trade-panel">
            <div style="display: flex;color: var(--theme-label);text-align: center;height: 36px;line-height: 36px;background: var(--theme-header);">
                <div @click="jiaoyiTypeClick(0)" :class="jiaoyiType == 0?'jy_btn jy_btn_active':'jy_btn'">买入</div>
                <div @click="jiaoyiTypeClick(1)" :class="jiaoyiType == 1?'jy_btn jy_btn_active':'jy_btn'">卖出</div>
            </div>
            <div style="color: var(--theme-label);margin-top: 4px;">
              <div class="cn-trade-contract-row">
                <div>
                  <el-select :value="heyueList.some(item => item.id === heyueid) ? heyueid : null" @input="heyueid = $event" :placeholder="heyueid ? '合约加载中…' : '请选择'" style="width: 100%;" @change="changeheyue()">
                    <el-option
                        v-for="(item,idx) in heyueList" :key="item.id"
                        :label="item.name+'['+item.consult_id+']'"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <button type="button" class="cn-contract-apply" @click="heyueApplyVisible = true">申请合约</button>
              </div>
              <div style="padding: 0 16px;">
                <div class="mb-6" style="display: flex;margin-top: 6px">
                  <div class="mr-2">最新价</div>
                  <div class="mr-10" :class="quoteTone(normalData.increase)"><button type="button" class="quote-price" :disabled="selPriceType !== 0" title="点击填入限价" @click="setLimitPrice(normalData.price)">{{ priceDisplay(normalData.price) }}</button>[{{ metric(normalData.increase, '%') }}]</div>
                  <div class="mr-2">涨停</div>
                  <div class="mr-10"><button type="button" class="quote-price" :disabled="selPriceType !== 0" title="点击填入限价" @click="setLimitPrice(normalData.maxprice)">{{ priceDisplay(normalData.maxprice) }}</button></div>
                  <div class="mr-2">跌停</div>
                  <div class="mr-10"><button type="button" class="quote-price" :disabled="selPriceType !== 0" title="点击填入限价" @click="setLimitPrice(normalData.minprice)">{{ priceDisplay(normalData.minprice) }}</button></div>
                </div>
                <div class="jy_input_box">
                  <div>
                    <el-select placeholder="限价" style="width: 80px;" v-model="selPriceType">
                      <el-option v-for="i in priceTypeList" :key="i.val" :label="i.name" :value="i.val"></el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-input placeholder="请输入价格" v-model="gpPrice" @input="filterInput()" @focus="gpPriceChange(0)" @blur="gpPriceChange(1)" v-if="selPriceType == 0"></el-input>
                    <el-input placeholder="市价" disabled v-if="selPriceType == 1"></el-input>
                  </div>
                  <div v-if="selPriceType == 0" style="display: flex;">
                    <div class="jy_add_btns" style="margin-right: 8px;" @click="setPriceCount(1,-0.01)">-</div>
                    <div class="jy_add_btns" @click="setPriceCount(1,0.01)" style="margin-right: 8px;">+</div>
                  </div>
                  <div v-if="selPriceType == 1" style="display: flex;">
                    <div class="jy_add_btns" style="margin-right: 8px;">-</div>
                    <div class="jy_add_btns" style="margin-right: 8px;">+</div>
                  </div>
                </div>
                <div class="jy_input_box">
                  <div>
                    <div style="width: 80px;height: 32px;line-height: 32px;text-align: center;border-right: 1px solid rgb(225, 195, 159);">数量</div>
                  </div>
                  <div>
                    <el-input placeholder="请输入数量" v-model="gpCount"></el-input>
                  </div>
                  <div style="display: flex;">
                    <div class="jy_add_btns" @click="setPriceCount(2,-100)" style="margin-right: 8px;">-</div>
                    <div class="jy_add_btns" @click="setPriceCount(2,100)" style="margin-right: 8px;">+</div>
                  </div>
                </div>
                <div v-if="selHeyueObj && jiaoyiType == 0" class="mb-6">可买<span>{{ kebuyCount }}</span>股</div>
                <div v-if="jiaoyiType == 1" class="mb-6">可卖<span>{{ kemaiCount }}</span>股</div>
                <div class="jy_d_bt_boxs mb-6">
                  <div @click="buyCount(0.25)" :class="selCangNum == 0.25?'jy_gp_boxs jy_gp_boxs_active':'jy_gp_boxs'">1/4</div>
                  <div @click="buyCount(0.33)" :class="selCangNum == 0.33?'jy_gp_boxs jy_gp_boxs_active':'jy_gp_boxs'">1/3</div>
                  <div @click="buyCount(0.5)" :class="selCangNum == 0.5?'jy_gp_boxs jy_gp_boxs_active':'jy_gp_boxs'">半仓</div>
                  <div @click="buyCount(1)" :class="selCangNum == 1?'jy_gp_boxs jy_gp_boxs_active':'jy_gp_boxs'">全仓</div>
                </div>
                <div class="jy_d_bt_boxs mb-6">
                  <div>成交额: <span>{{ jiaoyie }}</span></div>
                  <div>可用余额: <span>{{ metric(selHeyueObj.available_money) }}</span></div>
                </div>
                <p class="trade-note">{{ jiaoyiType == 0 ? '当前系统买入须为100股整数倍。参考金额不含手续费，市价以实际成交为准。' : '可卖数量及可交易状态以服务端校验为准。参考金额不含手续费，市价以实际成交为准。' }}</p>
              </div>
             
            </div>

            
          </section>
      </div>
      <div class="stock-trade-actions">
        <button type="button" class="jy_btns" v-if="jiaoyiType == 0" :disabled="showLoading" @click="prepareOrder">买入</button>
        <button type="button" class="jy_btns" v-if="jiaoyiType == 1" :disabled="showLoading || !(Number(kemaiCount) > 0)" style="background: #1890ff;" @click="prepareOrder">卖出</button>
      </div>
        </div>
        <el-dialog :title="dialog_title" :visible.sync="dialogVisible" :append-to-body="drawer" :show-close="!showLoading" :close-on-click-modal="!showLoading" :close-on-press-escape="!showLoading" width="460px" custom-class="pc-trade-dialog">
          <div class="pc-order-details">
            <div style="display: flex;">
              <div class="con_name">合约账户</div>
              <div class="con_value">{{selHeyueObj.name}}[{{selHeyueObj.consult_id}}]</div>
            </div>
            <div style="display: flex;">
              <div class="con_name">名称</div>
              <div class="con_value">{{normalData.name}}</div>
            </div>
            <div style="display: flex;">
              <div class="con_name">代码</div>
              <div class="con_value">{{symbol}}</div>
            </div>
            <div style="display: flex;">
              <div class="con_name">订单类型</div>
              <div class="con_value">{{ priceTypeList[selPriceType].name }}</div>
            </div>
            <div style="display: flex;">
              <div class="con_name">委托价</div>
              <div class="con_value" v-if="selPriceType == 0">{{ priceDisplay(gpPrice) }}</div>
              <div class="con_value" v-else>--</div>
              
            </div>
            <div style="display: flex;">
              <div class="con_name">数量</div>
              <div class="con_value">{{Math.floor(gpCount)}}</div>
            </div>
            <div style="display: flex;">
              <div class="con_name">订单金额</div>
              <div class="con_value">{{jiaoyie}}</div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer order-confirm-actions">
            <el-button :disabled="showLoading" @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="showLoading" :disabled="showLoading" :class="{ 'order-confirm-sell': jiaoyiType === 1 }" @click="confirmDef()">{{jiaoyiType == 0?'买 入':'卖 出'}}</el-button>
          </span>
        </el-dialog>
        <el-dialog custom-class="pc-contract-apply" title="申请合约" :visible.sync="heyueApplyVisible" :append-to-body="drawer" width="760px">
          <HeyueApply v-if="heyueApplyVisible" @success="contractCreated" />
              
        </el-dialog>
   </div>
</template>

<script>
import { quoteTone } from '@/utils/quoteColors'
    import HeyueApply from '../../components/heyueApply';
    import TradeTicks from '../../market/components/TradeTicks.vue'
    import {apiBaseData, apiBuySell, apiConsultList, apiMingXi, apiStockRiseRank,floatList,getPosition,guPiaoSellApi,guPiaoBuyApi} from "@/utils/requestapis";
    import { getStockQuotes } from '@/utils/stockQuotes'
    import { sharedStockRow } from '@/utils/stockQuoteFeed'
    import { pollMarket } from '@/utils/marketRefresh'
    import { quoteNumber, quoteDisplay, quotePrice } from '@/utils/quoteDisplay'
    import {getCache} from "@/utils/cache";
    import { isTradingTime } from "@/utils/config";
    export default {
        name: "ChinaStockTrade",
        props: {
            drawer: { type: Boolean, default: false },
            workspaceManaged: Boolean,
            workspaceContracts: { type: Array, default: () => [] },
            workspaceInfo: { type: Object, default: () => ({}) },
            workspacePositions: { type: Array, default: () => [] },
            workspaceQuote: { type: Array, default: () => [] },
            initialContractId: { type: Number, default: 0 },
            symbol: {
                type: String,
                default: ""
            }
        },
        components: {
          HeyueApply, TradeTicks
        },
        data() {
            return {
              metricsOpen: !this.drawer, bookOpen: false,
              orderTab: 0,
              baseData:{},
              mingxi:[],
              mingxi1:[],
              mingxi2:[],
              buySell1:[
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                  ],
              buySell2:[
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                    {'price': '--','vol': '--'},
                  ],
              heyueList:[],
              heyueid:0,
              selHeyueObj:{},
              selGuPiaoObj:{},
              jiaoyiType:0,

              gpCount:100,
              gpPrice:0,
              isopen:false,
              showLoading:false,
              quoteBusy:false, quoteReady:false, quoteError:'',
              // 股票字段
              normalDataSnapshot:{
                name : '--',
                price :  '--',
                high :  '--',
                low :  '--',
                zhang :  '--',
                ping :  '--',
                die : '--',
                increase: '--',
                maxprice: '--',
                minprice: '--',
                todayOpen : '--',
                yesClose : '--',
                zhenfu : '--',
                chengjiao : '--',
                time : '--',
              },
              priceTypeList:[{
                name:'限价',
                val:0
              },{
                name:'市价',
                val:1
              }],
              selPriceType:0,
              gpPriceRs:1,
              selCangNum:0,
              chiCangList:[],
              dialogVisible:false,
              dialog_title:'确认买入',
              heyueApplyVisible:false
            }
        },
        watch: {
          initialContractId(id) { if (Number(id) !== Number(this.heyueid)) { this.heyueid = Number(id) || 0; if (this.workspaceManaged) this.syncWorkspace(); else this.getHeyueList().then(() => this.getPositionList()) } },
          workspaceContracts() { this.syncWorkspace() }, workspaceInfo() { this.syncWorkspace() }, workspacePositions() { this.syncWorkspace() },
          workspaceQuote(data) { if (this.workspaceManaged) this.applyTencentQuote(data) },
          'normalData.price'(price) { if (this.workspaceManaged && this.gpPrice == 0 && this.gpPriceRs === 1 && quoteNumber(price) > 0) this.gpPrice = price },
          symbol() {
            this.quoteReady = false; this.normalData = {}; this.quoteError = ''; this.gpPrice = 0; this.gpPriceRs = 1
            this.buySell1 = []; this.buySell2 = []
            this.$nextTick(() => { if (!this.disposed) this.childMethod(0) })
          }
        },
        mounted:function()
        {
            this.heyueid = this.initialContractId
            this.init()
            if (!this.workspaceManaged) this.stopQuotes = pollMarket(() => this.symbol && !this.quoteBusy ? this.getTencentData(this.symbol) : undefined, 1000, 'cn')
        },
        beforeDestroy() { this.disposed = true; if (this.stopQuotes) this.stopQuotes() },
        computed:{
          normalData: { get() { return sharedStockRow({ ...this.normalDataSnapshot, full_code: this.symbol }, 'cn', 'cn-trade') }, set(value) { this.normalDataSnapshot = value } },
          jiaoyie(){
            var m=0,s1=String(this.gpCount),s2=String(this.gpPrice);
            try{m+=s1.split(".")[1].length}catch(e){}
            try{m+=s2.split(".")[1].length}catch(e){}
            let num = Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
            if(!Number.isFinite(num) || quoteNumber(this.gpPrice) == null || quoteNumber(this.gpCount) == null){
              return '--'
            }
            return num
          },
          kemaiCount(){
            let num = 0
            for(let i = 0;i<this.chiCangList.length;i++){
              if(String(this.chiCangList[i].code || '').replace(/^(sh|sz|bj)/i, '').split('.')[0] === this.symbol.split('.')[0]){
                num = this.chiCangList[i].hand
                break
              }
            }
            return Number.isFinite(Number(num)) ? num : '--'
          },
          kebuyCount(){
            let num = 0
            if(this.selHeyueObj.available_money && this.gpPrice != 0){
              
              num = parseInt((this.selHeyueObj.available_money/this.gpPrice/100)*100)
            }
            return Number.isFinite(num) ? num : '--'
          }
        },
        methods: {
          syncWorkspace() {
            if (!this.workspaceManaged || this.disposed) return
            this.heyueList = this.workspaceContracts.map(item => ({ ...item, id: Number(item.id) }))
            const info = Number(this.workspaceInfo.id) === Number(this.heyueid) ? this.workspaceInfo : this.heyueList.find(item => Number(item.id) === Number(this.heyueid))
            this.selHeyueObj = info || {}
            this.chiCangList = Array.isArray(this.workspacePositions) ? this.workspacePositions : []
            this.selGuPiaoObj = { code: this.symbol.split('.')[0], symbol: this.symbol }
          },
          setLimitPrice(value) {
            const price = quoteNumber(value)
            if (this.selPriceType !== 0 || !(price > 0)) return
            this.gpPrice = String(price)
            this.gpPriceRs = 0
          },
            quoteTone,
            priceTone(price) { return Number(price) > 0 && Number(this.normalData.yclose) > 0 ? quoteTone(Number(price) - Number(this.normalData.yclose)) : '' },
          metric: quoteDisplay,
          priceDisplay: quotePrice,
          jiaoyiTypeClick(idx){
            this.jiaoyiType = idx
            if(this.jiaoyiType == 0){
              this.dialog_title = '确认买入'
            }else{
              this.dialog_title = '确认卖出'
            }
            
          },
          changeheyue(){
            this.selHeyueObj = this.heyueList.find(item => Number(item.id) === Number(this.heyueid)) || {}
            this.getPositionList()
            this.$emit('contract-selected', this.heyueid)
          },
          requireContract() {
            if (Number(this.heyueid) > 0 && Number(this.selHeyueObj.id) === Number(this.heyueid)) return true
            this.$message.warning('请选择合约')
            return false
          },
          requireSellable() {
            const available = quoteNumber(this.kemaiCount), count = quoteNumber(this.gpCount)
            if (!(available > 0)) { this.$message.warning('当前股票暂无可卖数量'); return false }
            if (!(count > 0) || !Number.isInteger(count) || count > available) { this.$message.warning('卖出数量须为正整数且不能超过可卖数量'); return false }
            return true
          },
          prepareOrder() {
            if (this.showLoading) return
            if (!this.requireContract() || (this.jiaoyiType == 1 && !this.requireSellable())) return
            this.dialogVisible = true
          },
          async contractCreated(event) {
            if (this.disposed) return
            this.heyueApplyVisible = false
            if (!event || !(event.id > 0)) return
            if (event.market !== 'cn') { this.$router.push({ path: '/stocks', query: { market: event.market, contractId: event.id } }); return }
            this.heyueid = event.id
            if (this.workspaceManaged) { this.$emit('contract-selected', event.id); this.$emit('updated'); return }
            await this.getHeyueList()
            if (this.disposed || this.heyueid !== event.id) return
            this.changeheyue()
          },
          	// 股票卖出
          guPiaoSell(){
            if (this.showLoading) return
            if (!this.requireContract()) return
            if (!this.requireSellable()) { this.dialogVisible = false; return }
            const selectedSymbol = this.symbol, selectedContract = this.heyueid
            let priceNum = Math.floor(this.gpCount)
            if(this.selPriceType == 1){
              var money = 0
            }else{
              var money = this.gpPrice
            }
            let arr = this.symbol.split('.')
            let code = arr[0]
            let data = {
              consult_id:this.selHeyueObj.id,
              num:priceNum,
              price:money,
              type:this.selPriceType,
              code:code
            }
            
            this.showLoading = true
            return guPiaoSellApi(data).then(async (res) => {
              if (this.disposed || this.symbol !== selectedSymbol || this.heyueid !== selectedContract) return
              if (res === 0 || res === undefined) return
              this.dialogVisible = false
              await this.getPositionList()
              this.$emit('updated')
            }).catch(() => { /* Shared request handler displays the failure. */ }).finally(() => { this.showLoading = false })
            //this.$http.guPiaoSell(data).then(res=>{
              // this.confirmBox = false
              // this.getEntrust()
              // this.getPosition()
              // if(res.code == 200){
              //   uni.showToast({
              //     title:res.data,
              //     icon:'none'
              //   })
              // }else{
              //   uni.showToast({
              //     title:res.msg,
              //     icon:'none'
              //   })
              // }
              // this.cancelMask()
            //})
          },
          		// 股票买入
          guPiaoBuy(){
            if (this.showLoading) return
            if (!this.requireContract()) return
            const selectedSymbol = this.symbol, selectedContract = this.heyueid
            let priceNum = Math.floor(this.gpCount)
            if(this.selPriceType == 1){
              var money = 0
            }else{
              var money = this.gpPrice
            }
            let arr = this.symbol.split('.')
            let code = arr[0]
            let data = {
              consult_id:this.selHeyueObj.id,
              num:priceNum,
              price:money,
              type:this.selPriceType,
              code:code
            }
            this.showLoading = true
            return guPiaoBuyApi(data).then(async (res) => {
              if (this.disposed || this.symbol !== selectedSymbol || this.heyueid !== selectedContract) return
              if (res === 0 || res === undefined) return
              this.dialogVisible = false
              await this.getPositionList()
              this.$emit('updated')
            }).catch(() => { /* Shared request handler displays the failure. */ }).finally(() => { this.showLoading = false })
            //this.$http.guPiaoBuy(data).then(res=>{
              // if(res.code == 200){
              //   uni.showToast({
              //     title:res.data,
              //     icon:'none'
              //   })
              // }else{
              //   uni.showToast({
              //     title:res.msg,
              //     icon:'none'
              //   })
              // }
              // this.getEntrust()
              // this.getPosition()
              // this.confirmBox = false
              // this.cancelMask()
            //})
          },
          
          confirmDef(){
            // if(this.showLoading){
            //   return false;
            // }
            // this.showLoading = true
            if(this.jiaoyiType == 0){
              return this.guPiaoBuy()
            }else{
              return this.guPiaoSell()
            }
          },
          buyCount(num){
            this.selCangNum = num
            if(this.jiaoyiType == 0){
              if(parseInt(this.selHeyueObj.available_money/this.gpPrice/100)*100 * num < 100){
                this.$alert('至少选择100股', '提示', {
                  confirmButtonText: '确定'
                })
                this.gpCount = 100
                return false
              }
              this.gpCount = parseInt(this.selHeyueObj.available_money/this.gpPrice/100)*100 * num
              this.gpCount =	Math.floor(this.gpCount/100) * 100
            }else{
              if(parseInt(this.kemaiCount*this.selCangNum) != 0){
                this.gpCount = parseInt(this.kemaiCount*this.selCangNum)
                if(this.kemaiCount > this.gpCount){
                  if(parseInt(this.kemaiCount*this.selCangNum) < 100){
                    this.$alert('至少选择100股', '提示', {
                      confirmButtonText: '确定'
                    })
                    this.gpCount = 100
                    return false
                  }
                  this.gpCount = Math.floor(this.gpCount/100) * 100
                }else{
                  this.gpCount = Math.floor(this.gpCount)
                }
                
              }
            }
          },
          filterInput() {
            this.gpPrice = this.gpPrice.replace(/[^\d.]/g, '');
            this.gpPrice = this.gpPrice.replace(/^\./g, "");    // 禁止以点开头
            this.gpPrice = this.gpPrice.replace(/(\.\d{2})\d+/g, '$1');
            this.gpPrice = this.gpPrice.replace(/(\..*)\./g, '$1');
            if(this.gpPrice.indexOf('.') < 0 && this.gpPrice !== '') {
              this.gpPrice = parseFloat(this.gpPrice);
            }  
          },
          gpPriceChange(idx){
            this.gpPriceRs = idx
          },
          setPriceCount(type,num){
            if(type == 1){
              if(num < 0){
                if(this.gpPrice > 0.01){
                  this.gpPrice = this.floatAdd(this.gpPrice,num)
                }
              }else{
                this.gpPrice = this.floatAdd(this.gpPrice,num)
              }
            }else{
              if(num < 0){
                if(this.gpCount > 100){
                  this.gpCount = this.floatAdd(this.gpCount,num)
                }
              }else{
                this.gpCount = this.floatAdd(this.gpCount,num)
              }
            }
          },
          floatAdd(arg1,arg2){
            arg1 = arg1.toString(), arg2 = arg2.toString();
            var arg1Arr = arg1.split("."), arg2Arr = arg2.split("."), d1 = arg1Arr.length == 2 ? arg1Arr[1] : "", d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
            var maxLen = Math.max(d1.length, d2.length);
            var m = Math.pow(10, maxLen);
            var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
            var d = arguments[2];
            return typeof d === "number" ? Number((result).toFixed(d)) : result;
          },
          // 获取我的持仓
          getPositionList(){
            if (this.disposed) return Promise.resolve()
            if (this.workspaceManaged) { this.syncWorkspace(); return Promise.resolve() }
            if (!(Number(this.heyueid) > 0)) { this.chiCangList = []; this.selHeyueObj = {}; return Promise.resolve() }
            const selectedContract = this.heyueid
            let data = {
              consult_id:this.heyueid
            }
            return getPosition(data).then((res) => {
              if (this.disposed || selectedContract !== this.heyueid) return
              if(res.detail && res.detail.id ){
                  this.chiCangList = res.order_list
                  this.selHeyueObj = res.detail
                  this.heyueid = this.selHeyueObj.id
                  //uni.setStorageSync('heyueidStorage',this.heyueid)
                  // this.getEntrust()
                  // this.consultWarnNotice()
                  if(!(this.selGuPiaoObj || this.selGuPiaoObj.code != undefined) && this.chiCangList.length>0){
                    if(this.isopen){
                      this.getTencentData(this.chiCangList[0].symbol)
                      //this.getTXMingxi(this.chiCangList[0].symbol)
                    }else{
                      this.getBaseData(this.chiCangList[0].symbol)
                      //this.getMingXi(this.chiCangList[0].symbol)
                    }
                    
                    this.selGuPiaoObj = this.chiCangList[0]
                  }
                
                }else{
                  // uni.switchTab({
                  //   url: '/pages/index/contract'
                  // });
                }
            })
            
          },
          getHeyueList(){
            if (this.disposed) return Promise.resolve()
            if (this.workspaceManaged) { this.syncWorkspace(); return Promise.resolve() }
            let data = {
              type:0
            }
            const selectedContract = this.heyueid
            return floatList(data).then((res) => {
                if (this.disposed || selectedContract !== this.heyueid) return
                if (!Array.isArray(res)) return
                let dataArr = res.map(item => ({ ...item, id: Number(item.id) }))
                if(dataArr.length>0){
                  for(let i = 0;i<dataArr.length;i++){
                    if(dataArr[i].id == this.heyueid){
                      dataArr[i].isSel = true
                      this.selHeyueObj = dataArr[i]
                    }else{
                      dataArr[i].isSel = false
                    }
                  }
                  this.heyueList = dataArr
                }
            })
          },
            	//闭盘的时候调用的数据  基本数据
          getBaseData(symbol){
            if (this.disposed) return Promise.resolve()
            if (this.workspaceManaged) { this.syncWorkspace(); this.applyTencentQuote(this.workspaceQuote); return Promise.resolve() }
            const selectedSymbol = this.symbol
            this.quoteBusy = true; this.quoteError = ''
            return apiBaseData({code:this.symbol || symbol}).then((res) => {
              if (this.disposed || this.symbol !== selectedSymbol) return
              const info = res && res.stock && res.stock[0]
              if (!info || !(quoteNumber(info.price) > 0)) throw new Error('行情数据不可用')
              // Existing vexe baseData forwards Tencent volume (lots) / turnover (万元).
              this.normalData = { ...info, vol: info.vol == null || info.vol === '' ? null : Number(info.vol) * 100, amount: info.amount == null || info.amount === '' ? null : Number(info.amount) * 10000 }
              this.normalData.time = info.date+info.time
              this.quoteReady = true
              if (this.gpPrice == 0 && this.gpPriceRs === 1) this.gpPrice = info.price
              this.buySell(symbol)
            }).catch(() => {
              if (!this.disposed && this.symbol === selectedSymbol) this.quoteError = this.quoteReady ? '行情暂未更新，当前显示最近一次数据' : '暂时无法获取该股票行情，请重试'
            }).finally(() => { if (!this.disposed && this.symbol === selectedSymbol) this.quoteBusy = false })
          },
          buySell(symbol){
            if (this.disposed || this.workspaceManaged) return
            const selectedSymbol = this.symbol
            apiBuySell({code:this.symbol}).then((res) => { 
              if (this.disposed || selectedSymbol !== this.symbol) return
              if(res.stock != undefined && res.stock[0].buy){
                this.buySell1 = res.stock[0].buy
                this.buySell2 = [...(res.stock[0].sell || [])].sort((a, b) => Number(a.price) - Number(b.price))
              }      
            }).catch(() => { /* Retain the last available book. */ })
          },
          // Both the standalone request and the workspace owner use this full-quote parser.
          applyTencentQuote(data) {
            if (this.disposed || !Array.isArray(data) || data.length <= 48 || !(quoteNumber(data[3]) > 0) || String(data[2]) !== this.symbol.split('.')[0]) return false
                      this.normalData = {
                        name : data[1],
                        price : data[3],
                        high : data[33],
                        low : data[34],
                        zhang : data[2],
                        ping : data[3],
                        die : data[4],
                        increase:data[32],
                        maxprice:data[47],
                        minprice:data[48],
                        open :data[5],
                        yclose :data[4],
                        exchangerate :data[38],
                        amplitude :data[43],
                        vol :Number.isFinite(Number(data[36])) && data[36] !== '' ? Number(data[36]) * 100 : null,
                        amount :Number.isFinite(Number(data[37])) && data[37] !== '' ? Number(data[37]) * 10000 : null,
                        marketvalue :data[45],
                        flowmarketvalue :data[44],
                        pe :data[39],
                        pb :data[46],
                        todayOpen :data[5],
                        yesClose :data[4],
                        zhenfu :data[43],
                        chengjiao :data[37],
                        time :data[30],
                      }
                      let buy = [
                        {'price':data[9],'vol':data[10]},
                        {'price':data[11],'vol':data[12]},
                        {'price':data[13],'vol':data[14]},
                        {'price':data[15],'vol':data[16]},
                        {'price':data[17],'vol':data[18]}
                      ];
                      this.buySell1 = buy;
                      let sell = [
                            {'price':data[19],'vol':data[20]},
                            {'price':data[21],'vol':data[22]},
                            {'price':data[23],'vol':data[24]},
                            {'price':data[25],'vol':data[26]},
                            {'price':data[27],'vol':data[28]}
                          ];
                      this.buySell2 = sell;
                      this.quoteReady = true
                      if(this.gpPrice == 0 && this.gpPriceRs == 1){
                        this.gpPrice = data[3]
                      }
            this.quoteError = ''
            return true
          },
          getTencentData(code) {
            if (this.disposed || this.workspaceManaged || !code || code === 'undefined') return Promise.resolve()
            const codestr = (code.split('.')[1] + code.split('.')[0]).toLowerCase(), selectedSymbol = this.symbol
            this.quoteBusy = true; this.quoteError = ''
            return getStockQuotes(codestr).then(quotes => {
              if (this.disposed || this.symbol !== selectedSymbol) return
              if (!this.applyTencentQuote(quotes[codestr])) throw new Error('行情数据不可用')
            }).catch(() => {
              if (!this.disposed && this.symbol === selectedSymbol) this.quoteError = this.quoteReady ? '行情暂未更新，当前显示最近一次数据' : '暂时无法获取该股票行情，请重试'
            }).finally(() => { if (!this.disposed && this.symbol === selectedSymbol) this.quoteBusy = false })
          },
          childMethod(type){
            if(type == 0){
              this.getBaseData(this.symbol)
            }else{
              this.getPositionList()
              this.getHeyueList()
            }
          },
            init(){
              if(this.symbol != ''){
                this.isopen =  isTradingTime();
                this.getPositionList()
                this.getHeyueList()
                this.getBaseData(this.symbol)
              }
            
            }
        }
    }
</script>

<style lang="scss" scoped>
.cn-trade-contract-row { display:flex; align-items:center; gap:8px; padding:0 16px; min-width:0; line-height:36px; }
.cn-trade-contract-row > div { flex:1; min-width:0; }
.cn-contract-apply { flex:none; padding:0; border:0; background:transparent; color:var(--theme-accent); white-space:nowrap; cursor:pointer; font:inherit; }
    .data-toggle { padding: 0; border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
    .data-toggle:focus-visible { outline: 2px solid var(--theme-accent); }
    .right-wrap { width: 100%; }
    .title_jy_box{
        display: flex;
        color: var(--theme-label);
        text-align: center;
        height: 36px;
        line-height: 36px;
        background: var(--theme-header);
        justify-content: space-between;
    }

      .div_c_t{
      width: 33.33%;
      text-align: center;
      height: 30px;
    }
    .div_c_w5{
      width: 50%;
      text-align: center;
      height: 30px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      background: var(--theme-input);
      color: var(--theme-label);
      border: none;
      height: 30px;
      line-height: 30px;
    }
    .el-select .el-input .el-select__caret {
      color: var(--theme-label);
      background: var(--theme-input);
      border: none;
      height: 30px;
      line-height: 30px;
    }
    .el-select .el-input::placeholder {
      color: var(--theme-label);
     }
    .he_ye_box div{
      text-align: center;
      line-height: 28px;
    }
    .jy_btn{
        width: 80px;
        text-align: center;
    }
    .jy_btn_active{
        color: var(--theme-text) !important;
        border-bottom: 2px solid var(--theme-text) !important;
    }
    .mr-10 {
      margin-right: 10px;
    }
    .mr-2 {
      margin-right: 2px;
    }
    .mb-6{
        margin-bottom: 6px;
    }
    .jy_add_btns{
        text-align: center;
        background: var(--theme-input);
        width: 32px;line-height: 26px;
        font-size: 28px;
        height: 32px;
        margin-top: 4px;
    }
    .jy_input_box{
        display:flex;
        padding: 10px 0;
        border: 1px solid rgb(225, 195, 159);
        border-radius: 6px;
        justify-content: space-between;
        margin-bottom: 10px;
        cursor: pointer;
    }
    .jy_gp_boxs{
        border: 1px solid rgb(225, 195, 159);
        text-align: center;
        width: 80px;
        border-radius: 4px;
    }
    .jy_d_bt_boxs{
        display:flex;
        justify-content: space-between;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
    }
    .jy_btns{
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        border: 0;
        font: inherit;
        cursor: pointer;
        background: #f93f30;
        text-align: center;
        color: #fff;
        height: 42px;
        line-height: 42px;
        border-radius: 6px;
    }
    .stock-trade-actions { padding: 10px 12px; background: var(--theme-bg); }
    .jy_btns:disabled { opacity: .5; cursor: not-allowed; }
    .jy_btns:focus-visible { outline: 2px solid var(--theme-accent); outline-offset: 2px; }
    .trade-note { color: var(--theme-muted); font-size: 12px; line-height: 18px; margin: 8px 0; }
    .jy_gp_boxs_active{
      border: 1px solid #f93f30;
      color: #f93f30;
    }
    .con_name{
      color: #666666;
      padding: 10rpx 0;width: 50%;
      height: 40px;line-height: 40px;
    }
    .con_value{
      text-align: right;width: 50%;
      height: 40px;line-height: 40px;
    }
   
</style>


